var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70711 0.292886C1.31658 -0.0976387 0.683416 -0.0976387 0.292892 0.292886C-0.0976326 0.68341 -0.0976326 1.31657 0.292892 1.7071L8.98529 10.3995L0.292913 19.0919C-0.0976105 19.4824 -0.0976109 20.1156 0.292913 20.5061C0.683438 20.8966 1.3166 20.8966 1.70713 20.5061L10.3995 11.8137L18.6777 20.0919C19.0682 20.4824 19.7014 20.4824 20.0919 20.0919C20.4824 19.7014 20.4824 19.0682 20.0919 18.6777L11.8137 10.3995L20.0919 2.12131C20.4824 1.73079 20.4824 1.09762 20.0919 0.707099C19.7014 0.316575 19.0682 0.316575 18.6777 0.707099L10.3995 8.98528L1.70711 0.292886Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.43dd3940d74c78366e89550cffe1e4af.svg";
export { ForwardRef as ReactComponent };